import { SubscriptionStatus } from '@heidi/schema/ml-scribe';

/** PRO / PRO_PLUS billing baseline before the clinician reverse trial (ninety-day trial path, Evidence welcome popover). */
export function isPreviousTrialNinetyDayTrial(
  status: SubscriptionStatus | string | null | undefined
): boolean {
  return status === SubscriptionStatus.PRO || status === SubscriptionStatus.PRO_PLUS;
}
